



























































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { BankCustodian } from "@/admin/types";
import * as elements from "@/shared/elementsUrls";
import {
  AppBrowserTarget,
  isMobileApp,
  openUrl
} from "@/shared/mobileHelper";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { FetchState } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class DisclosureLinks extends Vue {

  custodianSettingsStore = useCustodianSettingsStore();
  featureFlags = useFeatureFlagStore();
  wizardStore = useDrivewealthWizardStore();

  ElementsUrls = elements;

  mounted (): void {
    this.wizardStore.loadDividendReinvestmentDisclosures({});
  }

  open (url) {
    openUrl(url, AppBrowserTarget.system);
  }

  get isLoaded () {
    return this.wizardStore.dividendReinvestmentDisclosures.fetchState === FetchState.Loaded;
  }

  get showElementsFeeSchedule () {
    return this.custodianSettingsStore.userHsaCustodian === BankCustodian.Elements;
  }

  get showEquitiesDisclosure () {
    return this.wizardStore.dividendReinvestmentDisclosures.dripDisclosureAcknowledgmentRequired &&
      !!this.wizardStore.dividendReinvestmentDisclosures.equitiesDripDisclosure;
  }

  get equitiesDripDisclosureUrl () {
    return this.wizardStore.dividendReinvestmentDisclosures &&
      this.wizardStore.dividendReinvestmentDisclosures.equitiesDripDisclosure.documentUrl;
  }

  get isMobile () {
    return isMobileApp();
  }

  get isHsab () {
    return this.custodianSettingsStore.userHsaCustodian === BankCustodian.HsaBank;
  }
}
